import { render, staticRenderFns } from "./AccordionWrapper.vue?vue&type=template&id=f0d63aa8&scoped=true&"
import script from "./AccordionWrapper.vue?vue&type=script&lang=js&"
export * from "./AccordionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AccordionWrapper.vue?vue&type=style&index=0&id=f0d63aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d63aa8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/AccordionWrapper.vue
// module id = 201
// module chunks = 0